// extracted by mini-css-extract-plugin
export var byline = "byline-module--byline--HGyhY";